import { sciIconModePostfix } from "@/const";

export function darkModeReplacePostfix(str: string, darkMode: boolean): string {
  if (Object.values(sciIconModePostfix).every(i => !str.includes(i))) return "";

  const replacer = darkMode ? sciIconModePostfix.DARK : sciIconModePostfix.LIGHT;
  const postfix = darkMode ? sciIconModePostfix.LIGHT : sciIconModePostfix.DARK;
  return str.replace(postfix, replacer);
}
